import React, { useRef, useState } from 'react'

import { Followups } from "./Followups"
import { Notes } from "./Notes"
import { Meetings } from "./Meetings"
import { Documents } from "./Documents"
import { Col, Dropdown, Nav, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faEllipsisV, faPencil, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useOutsideClickHandler } from '../../../Utils/hooks/useOutsideClickHandler'
import { toast } from 'sonner'
import useLocalStorageState from 'use-local-storage-state'
import { CreateLead } from '../../Leads/CreateLead'
import DeleteModal from '../../DeleteModal'
import { DeleteRequest } from '../../../Utils/hooks/ApiHandler'
import { useGlobalState } from '../../../Utils/hooks/useFilterQueryValue'
import { useGetEssentials } from '../../../Utils/hooks/useGetEssentials'
import { fetchTemporaryFilterData, navigateBackFromCrmDetail } from '../../../Utils/helpers/commonhelper'
import { useLocation } from 'react-router-dom'

export const RightLeadDetailsPanel = ({
    leadId,
    leadData,
    canEdit_canDownload,
    setCallLogOpen,
    selectedStageId,
    setSelectedStageId,
    selectedPipelineId,
    // just to ensure if actions dropdown is to be shown necessarily or not
    isActionDropReqd,
    refetchLeads
}) => {
    const { headers, extras, navigate, loginUserId } = useGetEssentials()
    const location = useLocation()

    const [PERMISSION, _] = useLocalStorageState('permission')
    const leadGrant = PERMISSION.leads;
    const followupGrant = leadGrant.feature.followup;
    const leadDocGrant = leadGrant.feature.document;
    const leadNoteGrant = leadGrant.feature.notes;
    const leadMeetingGrant = leadGrant.feature.meeting;
    // Active tab state for lazy loading
    const [activeTab, setActiveTab] = useState("followups")

    const leadsMetadata = localStorage.getItem('leadsMetadata')
    const currAdvFilter = leadsMetadata?.currAdvFilter

    // delete modal state
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const [showEditLead, setShowEditLead] = useState(false)

    const [leadsApplyFilterParams] = useGlobalState('leadsApplyFilterDataParams')

    const handleCloseLeadDetails = () => {
        navigateBackFromCrmDetail(navigate, location, '/leads', {
            beforeNavigate: () => {
                if (currAdvFilter === "apply") {
                    fetchTemporaryFilterData(leadsApplyFilterParams?.applyFilterData)
                }
            },
        })
    }

    const [deleteLeadId, setDeleteLeadId] = useState(null)
    // deletion state loader
    const [loading, setLoading] = useState(false)

    // Dropdown state for three dots menu
    const [showActionsDropdown, setShowActionsDropdown] = useState(false)
    const actionsDropdownRef = useRef(null)

    // Close dropdowns on outside click
    useOutsideClickHandler({
        objRef: actionsDropdownRef,
        isDropdown: showActionsDropdown,
        setDropdown: setShowActionsDropdown
    })

    // Toggles actions dropdown menu
    const toggleActionsDropdown = () => setShowActionsDropdown((prev) => !prev)
    // Closes actions dropdown
    const closeActionsDropdown = () => setShowActionsDropdown(false)

    // Handles edit action
    // const handleEdit = () => {
    //     if (onEdit && leadData) {
    //         onEdit(leadData.id)
    //     }
    //     closeActionsDropdown()
    //     onClose()
    // }

    // Open edit lead form with specific lead ID
    const handleEditLead = (leadId) => {
        if (!leadGrant.isEdit) {
            toast.warning("You are not authorized for this action!")
            return
        }
        setSelectedStageId(null)
        setShowEditLead(true)
    }

    // Handles delete action
    // const handleDelete = () => {
    //     if (onDelete && leadData) {
    //         onDelete(leadData.id)
    //     }
    //     closeActionsDropdown()
    //     onClose()
    // }
    // Show delete confirmation modal for lead
    const handleDeleteLead = (leadId) => {
        if (!leadGrant.isDelete) {
            toast.warning("You are not authorized for this action!")
            return
        }
        setDeleteLeadId(leadId)
        setShowDeleteModal(true)
        closeActionsDropdown()
    }
    const handleDeleteConfirm = async () => {
        try {
            setLoading(true)
            const response = await DeleteRequest(`lead/deleteLead/${deleteLeadId}/${loginUserId}`, { headers }, extras)
            if (response.status === "fail" || response.success === false) {
                toast.error(response.message)
                setLoading(false)
                return
            }
            toast.success(response.message)
            setLoading(false)
            if (currAdvFilter === "apply") {
                fetchTemporaryFilterData(leadsApplyFilterParams?.applyFilterData)
                return
            }
            // setCurrAdvFilter(null)
            // setFilterState([])
            // setTempFilterData(null)
            // setCustomFilter(null)
            // refetchLeads()
            navigate('/leads')

        } catch (error) {
            toast.error("An error occurred while deleting lead")
            setLoading(false)
        } finally {
            setShowDeleteModal(false)
            setDeleteLeadId(null)
            setLoading(false)
        }
    }

    // Handles tab change and sets active tab for lazy loading
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey)
    }
    // Close create lead form and reset selection
    const handleCreateLeadClose = () => {
        setShowEditLead(false)
        setSelectedStageId(null)
    }
    return (
        <>
            <Col md={5} className="ps-2 h-100" style={{ paddingRight: 1, minHeight: 0 }}>
                <div style={{ overflow: "hidden", height: "100%" }} className="">
                    <Tab.Container activeKey={activeTab || "followups"} onSelect={handleTabChange}>
                        <div className="card h-100 cardBorders" >
                            <div className="card-header d-flex justify-content-between align-items-center px-3 py-0 cardHeaderBorders">
                                <div style={styles.ulStyles}>
                                    <div className="d-flex align-items-center gap-1 h-100">
                                        <Nav variant="pills" className="nav-style-1 mb-0 d-flex flex-nowrap navItemsBeforeStyle gap-2">
                                            <Nav.Item className="me-3" style={{ width: "65px" }}>
                                                <Nav.Link eventKey="followups" className="p-0">
                                                    FollowUps
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="notes" className="p-0">
                                                    Notes
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="meetings" className="p-0">
                                                    Meetings
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="documents" className="p-0">
                                                    Documents
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        {/* Three dots menu */}
                                        {isActionDropReqd && (
                                            <div ref={actionsDropdownRef} className="position-relative">
                                                <Dropdown
                                                    show={showActionsDropdown}
                                                >
                                                    {
                                                        leadData?.lead_status?.toLowerCase() !== "won" &&
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            style={styles.listWhatsButtonsStyles}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setShowActionsDropdown(prev => !prev)
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faEllipsisV} style={styles.iconStyles} />
                                                        </button>
                                                    }
                                                    {showActionsDropdown &&
                                                        <Dropdown.Menu
                                                            className="defaultDropdown"
                                                            style={{
                                                                width: "10rem",
                                                                padding: "7px 0px",
                                                                display: "block",
                                                                position: "fixed",
                                                                top: actionsDropdownRef.current
                                                                    ? actionsDropdownRef.current.getBoundingClientRect().bottom + window.scrollY
                                                                    : 0,
                                                                left: actionsDropdownRef.current
                                                                    ? actionsDropdownRef.current.getBoundingClientRect().right - 160 + window.scrollX
                                                                    : 0,
                                                                zIndex: 9999,
                                                                backgroundColor: "#fff",
                                                                border: "1px solid #dee2e6",
                                                                borderRadius: "0.375rem",
                                                                boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)"
                                                            }}
                                                        >
                                                            <Dropdown.Item onClick={() => {
                                                                if (!leadGrant.isEdit) {
                                                                    toast.warning("You are not authorized for this action!")
                                                                    return
                                                                }
                                                                if (!canEdit_canDownload) {
                                                                    toast.warning("Your account has read-only access across this shared pipeline.")
                                                                    return
                                                                }
                                                                handleEditLead(leadId)
                                                            }} className="fs-13 d-flex gap-2 align-items-center">
                                                                <FontAwesomeIcon icon={faPencil} /> Edit Lead
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    if (!leadGrant.isDelete) {
                                                                        toast.warning("You are not authorized for this action!")
                                                                        return
                                                                    }
                                                                    if (!canEdit_canDownload) {
                                                                        toast.warning("Your account has read-only access across this shared pipeline.")
                                                                        return
                                                                    }
                                                                    handleDeleteLead()
                                                                }}
                                                                className="fs-13 d-flex gap-2 align-items-center"
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} /> Delete Lead
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    setCallLogOpen(true);
                                                                }}
                                                                className="fs-13 d-flex gap-2 align-items-center"
                                                            >
                                                                <FontAwesomeIcon icon={faCalendar} />
                                                                Call Log
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    }
                                                </Dropdown>
                                            </div>
                                        )}
                                        {
                                            isActionDropReqd &&
                                            <>
                                                <div style={styles.emptyDivs}></div>
                                                <button
                                                    type="button"
                                                    className="btn btn-default"
                                                    style={styles.listWhatsButtonsStyles}
                                                    onClick={handleCloseLeadDetails}
                                                >
                                                    <FontAwesomeIcon icon={faXmark} style={styles.iconStyles} />
                                                </button>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div
                                className="px-0 pt-0 flex-grow-1"
                                style={{ minHeight: 0, overflow: "hidden" }}
                            >
                                <Tab.Content
                                    className="h-100 d-flex flex-column"
                                    style={{ minHeight: 0 }}
                                >
                                    <Tab.Pane
                                        eventKey="followups"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Followups followupGrant={followupGrant} leadId={leadId} module_name={"lead"} isLeadWon={leadData?.lead_status?.toLowerCase() === "won" ? true : false} />
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="notes"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Notes noteGrant={leadNoteGrant} leadId={leadId} isActive={activeTab === "notes"} module_name={"leads"} isLeadWon={leadData?.lead_status?.toLowerCase() === "won" ? true : false} />
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="meetings"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        {
                                            leadData?.email &&
                                            <Meetings leadId={leadId} meetingGrant={leadMeetingGrant} isActive={activeTab === "meetings"} email={leadData?.email} fullName={leadData?.contact_name} module_name={"leads"} isLeadWon={leadData?.lead_status?.toLowerCase() === "won" ? true : false} />
                                        }
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="documents"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Documents leadId={leadId} documentGrant={leadDocGrant} isActive={activeTab === "documents"} module_name={"leads"} isLeadWon={leadData?.lead_status?.toLowerCase() === "won" ? true : false} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div >
            </Col >

            {/* Create/Edit Lead Modal */}
            < CreateLead
                show={showEditLead}
                onHide={handleCreateLeadClose}
                setLeadClose={setShowEditLead}
                editId={leadId}
                stageId={selectedStageId}
                pipelineId={selectedPipelineId}
                refetchLeads={refetchLeads}
                module_name="leads"
            />
            {/* Delete Lead Confirmation Modal */}
            <DeleteModal
                show={showDeleteModal}
                onClose={() => {
                    setDeleteLeadId(null)
                    setShowDeleteModal(false)
                }}
                onConfirm={handleDeleteConfirm}
                isLoading={loading}
                message="Are you sure you want to delete this lead?"
            />
        </>

    )
}

const styles = {
    bottomP: {
        fontSize: 11,
    },
    bottomH4: {
        marginBottom: 2,
    },
    buttons: {
        color: "#fff",
        fontSize: "13px",
        height: "34px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    filterbuttons: {
        fontSize: "13px",
        height: "33px",
        width: "33px",
        maxHeight: 33,
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    ulStyles: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
        width: "100%",
    },
    listButtonsStyles: {
        fontSize: "18px",
        height: "34px",
        width: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    listWhatsButtonsStyles: {
        fontSize: "13px",
        height: "29px",
        gap: 5,
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    navButtonsStyles: {
        fontSize: "15px",
        height: "34px",
        minWidth: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    iconStyles: {
        fontSize: 12,
        color: "#fff",
    },
    emptyDivs: {
        borderRight: "1px solid #E0E4F8",
        height: "35px",
        margin: "0px 2px",
    },
    DropdownItemsStyle: {
        fontSize: ".93re",
        letterSpacing: ".0386rem",
        fontWeight: 400,
        color: "#2e384d",
    },
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
        pointerEvents: "none",
    },
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    stickyHeader: {
        paddingBottom: "12px",
        paddingTop: "12px",
        position: "sticky",
        background: "#fff",
        top: "0px",
        background: "#fff",
        borderRadius: 0,
        borderBottom: "1px solid rgb(224, 228, 248)",
        borderTop: "1px solid rgb(224, 228, 248)",
        borderLeft: "1px solid rgb(224, 228, 248)",
        borderRight: "1px solid rgb(224, 228, 248)",
        zIndex: 1,
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    iconsStyles: {
        color: "#2656a8",
        border: "1px solid #e6e6e6",
        background: "#e9f1ff",
        padding: "8px",
        borderRadius: "50%",
        marginRight: "10px",
        width: "11px",
        height: "11px",
        fontSize: "13px",
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
        letterSpacing: "0.25px"
    },
    sectionTitle: {
        fontSize: "17px",
        fontWeight: 300,
        marginLeft: "14px",
        marginBottom: "19px",
    },
}

